import React, { useEffect, useContext, useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../Providers/UserContext";
import {
	BannerSection,
	BannerSectionItem,
	BarContainer,
	BonuseLinkCircleText,
	BonuseLinkHeader,
	BonuseLinkSubHeader,
	BoxContainer,
	CardContent,
	CardHeader,
	CardMessage,
	CardSvg,
	FreeMoneyBtn,
	FreeMoneyCoin,
	FreeMoneyHeader,
	FreeMoneyLink,
	FreeMoneySubHeader,
	GameCard,
	GameCardContainer,
	HomeSectionGameList,
	HomeSectionGames,
	HomeSectionHeader,
	HomeSectionHeaderContent,
	HomeSectionHeaderTitle,
	ImageSlide,
	LandingContainer,
	LandingContent,
	LandingHeader,
	LandingPromos,
	MobileHomeContainer,
	MobileHomeSectionContainer,
	MobilePromotionLinkContainer,
	PromoCard,
	PromotionBtn,
	SectionCardContent,
	SectionCardHeader,
	SectionCardLeft,
	SectionCardLeftContent,
	SectionCardRight,
} from "./styled";

import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import MobileNavFooter from "../../layout/MobileFooter/MobileNavFooter";
import MobileFooter from "../../layout/MobileFooter";
import ImageSlider from "../../components/ImageSlider";

import { Win } from "../../assets/svg/win";
import { Pocker } from "../../assets/svg/pocker";
import CashBackImg from "../../assets/image/box/bonus-banner-cashback-casino.avif";
import BonusImg from "../../assets/image/box/bonus-banner-deposit.avif";
import PockerBannerbg from "../../assets/image/home-poker-banner.webp";
import presentLight from "../../assets/image/present-with-light.bd57fb068-151.png";
import { PromotionIcon } from "../../assets/svg/promotion";
import axios from "axios";
import { useTypedSelector } from "../../store/typeHooks";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export type Game = {
	gameCode: string;
	name: string;
	softwareProvider?: string;
	uuid: string;
};

const PROMOS = [
	{ header: "TVBET", message: "Live Games 24/7" },
	{ header: "Сasino", message: "Over 3000 games" },
	{ header: "Live-Games", message: "Live dealers" },
	{ header: "Poker", message: "Free Tournaments" },
] as const;

const PLACEHOLDER_GAME_CARDS = 4;
const PLACEHOLDER_CASINO_CARDS = 12;

const Landing: React.FC = () => {
	const navigate = useNavigate();
	const { games, setGames, isOrder } = useContext(UserContext);
	const { isLogin } = useTypedSelector((state) => state.auth);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchGames = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);
			const { data } = await axios.get<Game[]>(
				"https://ss.game-services.work/platform/api/games"
			);
			setGames(Array.isArray(data) ? data : []);
		} catch (e) {
			console.error("Failed to fetch games:", e);
			setError("Failed to load games. Please try again.");
			setGames([]);
		} finally {
			setLoading(false);
		}
	}, [setGames]);

	useEffect(() => {
		if (isOrder) fetchGames();
	}, [isOrder, fetchGames]);

	const handleGamePlay = useCallback(
		(gameItem: Game) => {
			if (isLogin) {
				navigate(`/casino/play/${gameItem.gameCode}`, {
					state: { gameItem, provider: gameItem.softwareProvider },
				});
			} else {
				navigate("/", { state: { modal: "login" } });
			}
		},
		[isLogin, navigate]
	);

	const gamesTop12 = useMemo(() => (games ?? []).slice(0, 12), [games]);

	console.log("games: ", gamesTop12);


	return (
		<LandingContainer>
			<Header />

			<LandingHeader>
				<ImageSlide>
					<ImageSlider />
				</ImageSlide>

				<BoxContainer imgurl={CashBackImg}>
					<span>Cashback up to 30% on casinos</span>
					<button onClick={() => navigate("/casino")}>Go to casino</button>
				</BoxContainer>

				<BoxContainer imgurl={BonusImg}>
					<span>Bonus + 500%</span>
					{!isLogin ? (
						<button onClick={() => navigate("/", { state: { modal: "register" } })}>
							Registration
						</button>
					) : (
						<button onClick={() => navigate("/", { state: { modal: "deposit" } })}>
							Get bonus
						</button>
					)}
				</BoxContainer>
			</LandingHeader>

			<LandingContent>
				<LandingPromos>
					{PROMOS.map((item, index) => (
						<PromoCard key={`${item.header}-${index}`}>
							<CardContent>
								<CardHeader>{item.header}</CardHeader>
								<CardMessage>{item.message}</CardMessage>
							</CardContent>
							<CardSvg />
						</PromoCard>
					))}
				</LandingPromos>

				<BannerSection>
					<BannerSectionItem>
						<BarContainer bartype={1} />
						<SectionCardHeader>
							<SectionCardLeft>
								<Win />
								<span>1win games</span>
							</SectionCardLeft>
							<SectionCardRight>All</SectionCardRight>
						</SectionCardHeader>
						<GameCardContainer>
							{Array.from({ length: PLACEHOLDER_GAME_CARDS }).map((_, index) => (
								!loading ?
									<GameCard key={`onewin-${index}`}>
									</GameCard> :
									<Skeleton height={130} borderRadius={12} baseColor="gray" />
							))}
						</GameCardContainer>
					</BannerSectionItem>

					<BannerSectionItem>
						<BarContainer bartype={2} />
						<img
							src={PockerBannerbg}
							style={{ position: "absolute", right: 0, height: "100%" }}
							alt="poker"
						/>
						<SectionCardHeader>
							<SectionCardLeft>
								<Pocker />
								<span>Poker</span>
							</SectionCardLeft>
							<SectionCardRight />
						</SectionCardHeader>
						<SectionCardContent>
							<span>Come in, play and win</span>
							<button onClick={() => navigate("/poker")}>Get bonus</button>
						</SectionCardContent>
					</BannerSectionItem>
				</BannerSection>

				<BannerSection>
					<BannerSectionItem>
						<BarContainer bartype={3} />
						<SectionCardHeader>
							<SectionCardLeft>
								<SectionCardLeftContent>
									<p>Casino</p>
									<span>{loading ? "…" : games?.length ?? 0}</span>
								</SectionCardLeftContent>
							</SectionCardLeft>
							<SectionCardRight onClick={() => navigate("/casino")}>
								All
							</SectionCardRight>
						</SectionCardHeader>

						{error ? (
							<div style={{ padding: 12 }}>
								<span>{error}</span>
								<button style={{ marginLeft: 8 }} onClick={fetchGames}>Retry</button>
							</div>
						) : (
							<GameCardContainer>
								{gamesTop12.map((gameItem, key) => (
									!loading ?
										<GameCard key={key} onClick={() => handleGamePlay(gameItem)}>
											<img src={`https://back-office.b-cdn.net/icons/${gameItem?.softwareProvider}/${gameItem?.gameCode}.png`} alt={gameItem?.name} width="100%" height="100%" />
										</GameCard> :
										<Skeleton height={130} borderRadius={12} baseColor="gray" />
								))}
							</GameCardContainer>
						)}
					</BannerSectionItem>

					<BannerSectionItem>
						<BarContainer bartype={4} />
						<SectionCardHeader>
							<SectionCardLeft>
								<SectionCardLeftContent>
									<p>Livegames</p>
									<span>326</span>
								</SectionCardLeftContent>
							</SectionCardLeft>
							<SectionCardRight>All</SectionCardRight>
						</SectionCardHeader>
						<GameCardContainer>
							{Array.from({ length: PLACEHOLDER_CASINO_CARDS }).map((_, index) => (
								!loading ? <GameCard key={`live-${index}`}>
								</GameCard> :
									<Skeleton height={130} borderRadius={12} baseColor="gray" />
							))}
						</GameCardContainer>
					</BannerSectionItem>
				</BannerSection>
			</LandingContent>

			<MobilePromotionLinkContainer>
				<FreeMoneyBtn>
					<FreeMoneyCoin />
					<FreeMoneyLink />
					<FreeMoneyHeader>Free money</FreeMoneyHeader>
					<FreeMoneySubHeader>Free cash!</FreeMoneySubHeader>
				</FreeMoneyBtn>
				<PromotionBtn>
					<PromotionIcon width="25px" height="25px" />
					<BonuseLinkCircleText>
						<BonuseLinkHeader>Promotions</BonuseLinkHeader>
						<BonuseLinkSubHeader>and bonuses</BonuseLinkSubHeader>
					</BonuseLinkCircleText>
					<img src={presentLight} alt="bonus" />
				</PromotionBtn>
			</MobilePromotionLinkContainer>

			<div style={{ padding: "0 15px" }}>
				<MobileHomeContainer>
					<MobileHomeSectionContainer>
						<HomeSectionHeader>
							<HomeSectionHeaderTitle>1win games</HomeSectionHeaderTitle>
							<HomeSectionHeaderContent>
								<label>All</label>
								<span>13 games</span>
							</HomeSectionHeaderContent>
						</HomeSectionHeader>
						<HomeSectionGameList>
							{Array.from({ length: 10 }).map((_, key) => (
								!loading ?
									<HomeSectionGames key={`onewin-mobile-${key}`}>
										<div>
										</div>
										<span>Lucky Jet</span>
									</HomeSectionGames> :
									<Skeleton height={120} borderRadius={12} baseColor="gray" />
							))}
						</HomeSectionGameList>
					</MobileHomeSectionContainer>

					<MobileHomeSectionContainer>
						<HomeSectionHeader>
							<HomeSectionHeaderTitle>Casino</HomeSectionHeaderTitle>
							<HomeSectionHeaderContent>
								<label onClick={() => navigate("/casino")}>All</label>
								<span>{games?.length ?? 0} games</span>
							</HomeSectionHeaderContent>
						</HomeSectionHeader>
						<HomeSectionGameList>
							{gamesTop12.map((item, key) => (
								!loading ?
									<HomeSectionGames
										key={`casino-mobile-${key}-${(item as Game)?.gameCode ?? 'skeleton'}`}
										onClick={() => !loading && item && handleGamePlay(item as Game)}
									>
										<div>
										</div>
										<span>{(item as Game)?.name ?? (loading ? "Loading…" : "Unknown Game")}</span>
									</HomeSectionGames> :
									<Skeleton height={120} borderRadius={12} baseColor="gray" />
							))}
						</HomeSectionGameList>
					</MobileHomeSectionContainer>

					<MobileHomeSectionContainer>
						<HomeSectionHeader>
							<HomeSectionHeaderTitle>Live-games</HomeSectionHeaderTitle>
							<HomeSectionHeaderContent>
								<label>All</label>
								<span>3954 games</span>
							</HomeSectionHeaderContent>
						</HomeSectionHeader>
						<HomeSectionGameList>
							{Array.from({ length: 10 }).map((_, key) => (
								!loading ?
									<HomeSectionGames key={`live-mobile-${key}`}>
										<div>
										</div>
										<span>Lucky Jet</span>
									</HomeSectionGames> :
									<Skeleton height={120} borderRadius={12} baseColor="gray" />
							))}
						</HomeSectionGameList>
					</MobileHomeSectionContainer>

					<MobileHomeSectionContainer>
						<HomeSectionHeader>
							<HomeSectionHeaderTitle>Games</HomeSectionHeaderTitle>
							<HomeSectionHeaderContent>
								<label>All</label>
								<span>150 games</span>
							</HomeSectionHeaderContent>
						</HomeSectionHeader>
						<HomeSectionGameList>
							{Array.from({ length: 10 }).map((_, key) => (
								!loading ?
									<HomeSectionGames key={`games-mobile-${key}`}>
										<div>
										</div>
										<span>Lucky Jet</span>
									</HomeSectionGames> :
									<Skeleton height={120} borderRadius={12} baseColor="gray" />
							))}
						</HomeSectionGameList>
					</MobileHomeSectionContainer>
				</MobileHomeContainer>
			</div>

			<Footer />
			<MobileFooter />
			<MobileNavFooter />
		</LandingContainer>
	);
};

export default Landing;
